import React, { useEffect, useState } from 'react';
import './Promoter.css';
import { BsCheckLg } from "react-icons/bs";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Promoter = ({ title, checklistItems, btnLabel1, btnLabel2, btnLabel1Link, btnLabel2Link, imageUrl }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { t } = useTranslation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Helper function to determine link type and render appropriate element
  const renderButton = (label, link, className) => {
    if (!label || !link) return null;

    // Internal link (starts with '/')
    if (link.startsWith('/')) {
      return <Link to={link} className={className}>{t(label)}</Link>;
    }
    // PDF link (ends with .pdf)
    else if (link.toLowerCase().endsWith('.pdf')) {
      return (
        <a href={link}
          className={className}
          target="_blank"
          rel="noopener noreferrer">
          {t(label)}
        </a>
      );
    }
    // External link (all other cases)
    else {
      return (
        <a href={link}
          className={className}
          target="_blank"
          rel="noopener noreferrer">
          {t(label)}
        </a>
      );
    }
  };

  useEffect(() => {
    AOS.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
      initClassName: 'aos-init', // class applied after initialization
      animatedClassName: 'aos-animate', // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 400, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 300, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    });
  }, []);


  return (
    <div>
      <div className="full-window">
        <div className="centered-div">
          <div className="centered-div-items">
            <h1 className='centered-div-title'>{t(title)}</h1>
            <ul className="checklist">
              {checklistItems.map((item, index) => (
                <li key={index}>
                  <Row>
                    <Col xs={1} sm={1} md={1} lg={1}><BsCheckLg className='li-promoter' /></Col>
                    <Col xs={11} sm={11} md={11} lg={11}>{t(item)}</Col>
                  </Row>
                </li>
              ))}
            </ul>
            <div className="button-container">
              {renderButton(btnLabel1, btnLabel1Link, "btn-pink")}
              {renderButton(btnLabel2, btnLabel2Link, "btn-pink")}
            </div>
          </div>
          {imageUrl && <img src={imageUrl} className="Karton-card-image" alt={t('Hansa-Flex Kartons Shop')} data-aos="fade-down"></img>}
        </div>
      </div>
    </div>
  );
};

export default Promoter;
